<style>
@import '../../assets/css/tool.css';
</style>

<template>
    <div class="main-panel" v-if="ajaxLoad === true">
        <div class="main-content">
            <div class="container-fluid">
                <b-card :header="$t($route.name)">
                    <b-button variant="primary" class="mb-3 float-right" @click="getAddBadge()" v-if="permissionList.includes(permission.add)"><font-awesome-icon icon="plus"/> {{$t('setting_badge.table_add')}}</b-button>
                    <el-table class="custom-table" :data="ajaxTable" @expand-change="expandChange" @row-click="expandRow" ref="tableTest" border>
                        <el-table-column v-for="title in titles" :prop="title.prop" :label="title.label" :key="title.prop" :min-width="title.width">
                            <template slot="header">
                                <p>{{title.label}}</p>
                                <b-form-input :placeholder="title.label" @keyup.enter="initialize()" v-model="ajaxSearch[title.prop]"></b-form-input>
                            </template>
                        </el-table-column>
                        <el-table-column type="expand">
                            <b-button variant="info" size="lg" @click="getEditBadge()" v-if="permissionList.includes(permission.edit)">{{$t('setting_badge.table_edit')}}</b-button>
                            <b-button variant="primary" size="lg" class="ml-1" @click="getAttributeBadge()">{{$t('setting_badge.table_badge_attribute')}}</b-button>
                            <b-button variant="danger" size="lg" class="ml-1" @click="deleteBadge()" v-if="permissionList.includes(permission.delete)">{{$t('setting_badge.table_delete')}}</b-button>
                        </el-table-column>
                    </el-table>
                    <b-row class="mt-3">
                        <b-col sm="12" md="3" class="pr-0">
                            <span class="float-left">{{$t('admin.table_show_result',{result:ajaxTool.total_number})}}</span>
                        </b-col>
                        <b-col sm="12" md="9" class="pl-0">
                            <el-pagination class="text-right" layout="sizes,prev, pager, next" @size-change="paginationSizeChange" @current-change="paginationCurrentChange" :current-page.sync="ajaxTool.current_pagination" :total="ajaxTool.total_number" :hide-on-single-page="1" :page-sizes="[10, 30, 50, 100]" :page-size="10" background></el-pagination>
                        </b-col>
                    </b-row>
                </b-card>
                
                <b-modal id="addBadge" :title="$t('setting_badge.table_add')" @ok="addBadge" :cancelTitle="$t('button.close')" :okTitle="$t('button.submit')">
                    <form id="addBadgeForm" @submit.prevent="addBadge">
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_code')}}</template>
                            <b-form-input name="code"></b-form-input>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_sort')}}</template>
                            <b-form-input name="sort" v-model="ajaxAdd.sort"></b-form-input>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_status')}}</template>
                            <b-form-checkbox name="status" size="lg" value="1" v-model="ajaxAdd.status" unchecked-value="0" switch></b-form-checkbox>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_remark')}}</template>
                            <b-form-input name="remark"></b-form-input>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="12" >
                            <template slot="label">{{$t('admin.table_name_title')}}</template>
                            <b-tabs class="center_pane" justified fill>
                                <b-tab v-for="(lang,key) in ajaxAdd.languageList" :key="key" :title="lang.name">
                                    <b-form-group label-cols="12" label-cols-lg="4">
                                        <template slot="label">{{$t('admin.table_name')}}</template>
                                        <b-form-input :name="'name[' + lang.code + ']'"></b-form-input>
                                    </b-form-group>
                                </b-tab>
                            </b-tabs>
                        </b-form-group>
                    </form>
                </b-modal>
                <b-modal id="editBadge" :title="$t('setting_badge.table_edit')" @ok="editBadge" :cancelTitle="$t('button.close')" :okTitle="$t('button.submit')">
                    <form id="editBadgeForm" @submit.prevent="editBadge">
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_code')}}</template>
                            <b-form-input name="code" v-model="ajaxEdit.code"></b-form-input>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_sort')}}</template>
                            <b-form-input name="sort" v-model="ajaxEdit.sort"></b-form-input>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_status')}}</template>
                            <b-form-checkbox name="status" size="lg" value="1" v-model="ajaxEdit.status" unchecked-value="0" switch></b-form-checkbox>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_remark')}}</template>
                            <b-form-input name="remark" v-model="ajaxEdit.remark"></b-form-input>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="12" >
                            <template slot="label">{{$t('admin.table_name_title')}}</template>
                            <b-tabs class="center_pane" justified fill>
                                <b-tab v-for="(lang,key) in ajaxEdit.languageList" :key="key" :title="lang.name">
                                    <b-form-group label-cols="12" label-cols-lg="4">
                                        <template slot="label">{{$t('admin.table_name')}}</template>
                                        <b-form-input :name="'name[' + lang.code + ']'" v-model="ajaxEdit.name[lang.code]"></b-form-input>
                                    </b-form-group>
                                </b-tab>
                            </b-tabs>
                        </b-form-group>
                    </form>
                </b-modal>
                <b-modal id="getAttributeBadge" :title="$t('setting_badge.table_attribute_title',{attribute:ajaxAttributeBadge})" size="lg " hide-footer>
                    <b-tabs class="center_pane" justified fill>
                        <b-tab :title="$t('setting_badge.table_attribute')" active>
                            <el-table class="custom-table" :data="ajaxAttributeTable" @expand-change="expandChangeAttribute" @row-click="expandRowAttribute" ref="tableAttribute" border>
                                <el-table-column v-for="title in attributeTitles" :prop="title.prop" :label="title.label" :key="title.prop" :min-width="title.width"></el-table-column>
                                <el-table-column type="expand">
                                    <b-button variant="info" @click="getEditAttributeBadge()" v-if="permissionList.includes(permission.attribute_edit)">{{$t('setting_badge.table_edit_attribute')}}</b-button>
                                    <b-button variant="danger" class="ml-1" @click="deleteAttributeBadge()" v-if="permissionList.includes(permission.attribute_delete)">{{$t('setting_badge.table_delete_attribute')}}</b-button>
                                </el-table-column>
                            </el-table>
                            <div class="mt-3">
                                <span class="float-left">{{$t('admin.table_show_result',{result:ajaxAttributeTool.total_number})}}</span>
                                <el-pagination class="text-right" layout="sizes,prev, pager, next" @size-change="paginationAttributeSizeChange" @current-change="paginationAttributeCurrentChange" :current-page.sync="ajaxAttributeTool.current_pagination" :total="ajaxAttributeTool.total_number" :hide-on-single-page="1" :page-sizes="[10, 30, 50, 100]" :page-size="10" background></el-pagination>
                            </div>
                        </b-tab>
                        <b-tab :title="$t('setting_badge.table_add_attribute')">
                            <form id="addAttributeBadge" @submit.prevent="addAttributeBadge">                            
                                <b-form-group label-cols="12" label-cols-lg="4">
                                    <template slot="label">{{$t('setting_badge.table_attribute')}}</template>
                                    <b-form-select class="mb-3" name="attribute_id">
                                        <option v-for="(list,index) in ajaxAttributeList" :key="index" :value="list.id">[{{list.code}}] - {{list.name}}</option>
                                    </b-form-select>
                                </b-form-group>
                                <b-form-group label-cols="12" label-cols-lg="4">
                                    <template slot="label">{{$t('setting_badge.table_attribute_value')}}</template>
                                    <b-form-input name="value"></b-form-input>
                                </b-form-group>
                                <b-form-group label-cols="12" label-cols-lg="4">
                                    <b-button variant="primary" @click="addAttributeBadge()" v-if="permissionList.includes(permission.attribute_add)">{{$t('button.submit')}}</b-button>
                                </b-form-group>
                            </form>
                        </b-tab>
                    </b-tabs>
                </b-modal>
                <b-modal id="getEditAttributeBadge" :title="$t('setting_badge.table_edit_attribute')" @ok="editAttributeBadge" hide-footer>
                    <form id="editAttributeBadge" @submit.prevent="editAttributeBadge">
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('setting_badge.table_attribute_value_select')}}</template>
                            <p class="mt-2">{{ajaxAttributeEdit.code}}</p>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label">{{$t('setting_badge.table_attribute_value')}}</template>
                            <b-form-input name="value" v-model="ajaxAttributeEdit.value"></b-form-input>
                        </b-form-group>
                        <b-button variant="primary" @click="editAttributeBadge()">{{$t('button.submit')}}</b-button>
                    </form>
                </b-modal>
            </div>
        </div>
    </div>
</template>

<script>
import {languageList,badgeAjaxTable,badgeAdd,getBadgeEdit,badgeEdit,badgeDelete,badgeAttributeAjaxTable,badgeAttributeAdd,getBadgeAttributeEdit,badgeAttributeEdit,badgeAttributeDelete,badgeAttributeLimit,badgeAttributePagination} from '@/system/model/tools'
import {removeTokenByName} from '@/system/store/cookie';
import {getSessionStorage,setSessionStorage } from '@/system/store/sessionstorage';
import {setLocalStorage, getLocalStorage} from '@/system/store/localstorage';

export default {
    inject:['preloader'],
    data(){
        return{   
            ajaxLoad:false,
            validate:true,
            ajaxTable:[],
            ajaxTool:[],
            ajaxSearch:{limit:'',pagination:'',id:'',code:'',remark:'',sort:'',status:'',name:''},
            ajaxAdd:{sort:10,status:1,languageList:[]},
            ajaxEdit:{languageList:[]},
            ajaxRow:'',
            ajaxAttributeTable:[],
            ajaxAttributeBadge:[],
            ajaxAttributeTool:[],
            ajaxAttributeSearch:[],
            ajaxAttributeEdit:[],
            ajaxAttributeList:[],
            ajaxAttributeRow:'',
            csrfName:'',
            csrfValue:'',
            csrfNameKey:'',
            csrfValueKey:'',
            pageLimit:10,
            errors: [],
            permission:{
                add:'3DFED8',
                edit:'E558B8',
                delete:'8D0DAA',
                attribute_add:'C9D003',
                attribute_edit:'719080',
                attribute_delete:'0C3F2E'
            },
            permissionList:[],
            titles:[{
                prop: "id",
                label: this.$t('admin.table_id'),
                width: '5'
            },{
                prop: "code",
                label: this.$t('admin.table_code'),
                width: '10'
            },{
                prop: "name",
                label: this.$t('admin.table_name'),
                width: '10'
            },{
                prop: "sort",
                label: this.$t('admin.table_sort'),
                width: '10'
            },{
                prop: "status",
                label: this.$t('admin.table_status'),
                width: '5'
            }], 
            attributeTitles:[{
                prop: "id",
                label: this.$t('admin.table_id'),
                width: '83'
            },{
                prop: "attribute_name",
                label: this.$t('setting_badge.table_attribute'),
                width: '250'
            },{
                prop: "value",
                label: this.$t('setting_badge.table_attribute_value'),
                width: '250'
            }], 
        }
    },methods:{
        initialize(){
            var self = this;
            var result = badgeAjaxTable(this.ajaxSearch.limit,this.ajaxSearch.pagination,this.ajaxSearch.id,this.ajaxSearch.code,this.ajaxSearch.remark,this.ajaxSearch.sort,this.ajaxSearch.status,this.ajaxSearch.name);
            this.preloader(true);
            result.then(function(value){
                self.preloader(false);
                if(value.valid){
                    self.ajaxLoad = true;
                    self.ajaxTable = value.data.datatable.data;
                    self.ajaxTool = value.data.datatable;
                    self.csrfName = value.data.csrf_list.csrf_name;
                    self.csrfValue = value.data.csrf_list.csrf_value;
                    self.csrfNameKey = value.data.csrf_list.csrf_name_key;
                    self.csrfValueKey = value.data.csrf_list.csrf_value_key;
                    self.permissionList = JSON.parse(getLocalStorage('permission_list'));
                }else{
                    self.$swal.fire({
                        type: 'error',
                        html: self.$t('login.error_relogin'),
                        onClose: () => {
                            removeTokenByName('auth_sign_token');
                            self.$router.push('/');
                        }
                    });		
                }
            });
        },getAddBadge(){
            if(this.permissionList.includes(this.permission.add)){
                var self = this;
                var result = languageList();
                this.preloader(true);
                result.then(function(value){
                    self.preloader(false);
                    if(value.valid){
                        self.ajaxAdd.languageList = value.data;
                        self.$bvModal.show('addBadge')
                    }
                });
            }
        },addBadge(){
            if(this.permissionList.includes(this.permission.add)){
                var self = this;
                this.preloader(true);
                var form = document.getElementById('addBadgeForm');
                var formData = new FormData(form);
                formData.append(this.csrfNameKey, this.csrfName); 
                formData.append(this.csrfValueKey, this.csrfValue); 
                var result = badgeAdd(formData);
                result.then(function(value){
                    self.preloader(false);
                    if(value.valid){
                        self.$swal.fire({
                            type: 'success',
                            text: self.$t(value.returnMsg),
                            onClose: () => {
                                self.initialize();            
                            }
                        });
                    }else{
                        var text = "";
                        if(Array.isArray(value.returnMsg)){
                            value.returnMsg.forEach(function (value) {
                                text += self.$t(value)+"<br />";
                            }); 
                        }else{
                            text = self.$t(value.returnMsg);
                        }

                        self.$swal.fire({
                            type: 'error',
                            html: text,
                            onClose: () => {
                                self.initialize();            
                            }
                        });
                    }
                });    
            }        
        },getEditBadge(){
            if(this.permissionList.includes(this.permission.edit)){
                var self = this;
                var result = getBadgeEdit(this.ajaxRow);
                this.preloader(true);
                result.then(function(value){
                    self.preloader(false);
                    if(value.valid){
                        self.$bvModal.show('editBadge');
                        self.ajaxEdit = value.data;
                        self.ajaxEdit.languageList = value.language;
                    }else{
                        var text = "";
                        this.errors.forEach(function (value) {
                            text += self.$t(value)+"<br />";
                        }); 
                        
                        this.$swal.fire({
                            type: 'error',
                            html: text,
                        });
                    }
                })
            }
        },editBadge(){
            if(this.permissionList.includes(this.permission.edit)){
                var self = this;
                this.preloader(true);
                var form = document.getElementById('editBadgeForm');
                var formData = new FormData(form);
                formData.append(this.csrfNameKey, this.csrfName); 
                formData.append(this.csrfValueKey, this.csrfValue); 
                formData.append('id', this.ajaxEdit.id); 
                var result = badgeEdit(formData);
                result.then(function(value){
                    self.preloader(false);
                    if(value.valid){
                        self.$swal.fire({
                            type: 'success',
                            text: self.$t(value.returnMsg),
                            onClose: () => {
                                self.initialize();            
                            }
                        });
                    }else{
                        var text = "";
                        if(Array.isArray(value.returnMsg)){
                            value.returnMsg.forEach(function (value) {
                                text += self.$t(value)+"<br />";
                            }); 
                        }else{
                            text = self.$t(value.returnMsg);
                        }

                        self.$swal.fire({
                            type: 'error',
                            html: text,
                            onClose: () => {
                                self.initialize();            
                            }
                        });
                    }
                })
            }
        },deleteBadge(){
            if(this.permissionList.includes(this.permission.delete)){
                this.$swal.fire({
                text: this.$t('msg.confirm_delete'),
                type: 'info',
                showCancelButton: true,
                confirmButtonText: this.$t('button.confirm'),
                cancelButtonText: this.$t('button.cancel'),
                }).then((result)=>{
                    if(result.value){
                        var self = this;
                        self.preloader(true);
                        var formData = new FormData();
                        formData.append(this.csrfNameKey, this.csrfName); 
                        formData.append(this.csrfValueKey, this.csrfValue); 
                        formData.append('id', this.ajaxRow); 
                        var result = badgeDelete(formData);		
                        result.then(function(value){
                            self.preloader(false);
                            if(value.valid){
                                self.$swal.fire({
                                    type: 'success',
                                    text: self.$t(value.returnMsg),
                                    onClose: () => {
                                        self.initialize();            
                                    }
                                });
                            }else{
                                self.preloader(false);
                                var text = "";
                                if(Array.isArray(value.returnMsg)){
                                    value.returnMsg.forEach(function (value) {
                                        text += self.$t(value)+"<br />";
                                    }); 
                                }else{
                                    text = self.$t(value.returnMsg);
                                }

                                self.$swal.fire({
                                    type: 'error',
                                    html: text,
                                    onClose: () => {
                                        self.initialize();            
                                    }
                                });
                            }
                        });
                    }
                });
            }
        },expandRow(row){
            this.$refs.tableTest.toggleRowExpansion(row);
            this.ajaxRow = row.id
        },expandChange(row,expandedRows){
            if(expandedRows.length>1){
                expandedRows.shift()
            }
        },paginationSizeChange(limit){
            this.ajaxSearch.limit = limit;
            this.initialize();
        },paginationCurrentChange(pagination){
            this.ajaxSearch.limit = this.pageLimit;
            this.ajaxSearch.pagination = pagination;
            this.initialize();
        },expandRowAttribute(row){
            this.$refs.tableAttribute.toggleRowExpansion(row);
            this.ajaxAttributeRow = row.id
        },expandChangeAttribute(row,expandedRows){
            if(expandedRows.length>1){
                expandedRows.shift()
            }
        },getAttributeBadge(){
            var self = this;
            var result = badgeAttributeAjaxTable(this.ajaxRow);
            this.preloader(true);
            result.then(function(value){
                self.preloader(false);
                self.$bvModal.show('getAttributeBadge');
                self.ajaxAttributeTable = value.data.datatable.data;
                self.ajaxAttributeList = value.data.attribute_list;
                self.ajaxAttributeBadge = value.data.badge.code;
                self.ajaxAttributeTool = value.data.datatable;
                self.csrfName = value.data.csrf_list.csrf_name;
                self.csrfValue = value.data.csrf_list.csrf_value;
                self.csrfNameKey = value.data.csrf_list.csrf_name_key;
                self.csrfValueKey = value.data.csrf_list.csrf_value_key;
            });
        },addAttributeBadge(){
            if(this.permissionList.includes(this.permission.attribute_add)){
                var self = this;
                var form = document.getElementById('addAttributeBadge');
                var formData = new FormData(form);
                formData.append(this.csrfNameKey, this.csrfName); 
                formData.append(this.csrfValueKey, this.csrfValue); 
                formData.append('badge_id', this.ajaxRow); 
                var result = badgeAttributeAdd(formData);
                self.preloader(true);
                result.then(function(value){
                    self.preloader(false);
                    if(value.valid){
                        self.$swal.fire({
                            type: 'success',
                            text: self.$t(value.returnMsg),
                            onClose: () => {                      
                                self.getAttributeBadge();
                            }
                        });
                    }else{
                        self.preloader(false);
                        var text = "";
                        if(Array.isArray(value.returnMsg)){
                            value.returnMsg.forEach(function (value) {
                                text += self.$t(value)+"<br />";
                            }); 
                        }else{
                            text = self.$t(value.returnMsg);
                        }

                        self.$swal.fire({
                            type: 'error',
                            html: text,
                            onClose: () => {
                                self.getAttributeBadge();
                            }
                        });
                    }
                });
            }
        },getEditAttributeBadge(){
            if(this.permissionList.includes(this.permission.attribute_edit)){
                var self = this;
                var result = getBadgeAttributeEdit(this.ajaxAttributeRow);
                this.preloader(true);
                result.then(function(value){
                    self.preloader(false);
                    self.$bvModal.show('getEditAttributeBadge');
                    self.ajaxAttributeEdit = value.data;
                });
            }
        },editAttributeBadge(){
            if(this.permissionList.includes(this.permission.attribute_edit)){
                var self = this;
                var form = document.getElementById('editAttributeBadge');
                var formData = new FormData(form);
                formData.append(this.csrfNameKey, this.csrfName); 
                formData.append(this.csrfValueKey, this.csrfValue); 
                formData.append('id', this.ajaxAttributeEdit.id); 
                var result = badgeAttributeEdit(formData);
                self.preloader(true);
                result.then(function(value){
                    self.preloader(false);
                    if(value.valid){
                        self.$swal.fire({
                            type: 'success',
                            text: self.$t(value.returnMsg),
                            onClose: () => {
                                self.$bvModal.hide('getEditAttributeBadge');                            
                                self.getAttributeBadge();
                            }
                        });
                    }else{
                        self.preloader(false);
                        var text = "";
                        if(Array.isArray(value.returnMsg)){
                            value.returnMsg.forEach(function (value) {
                                text += self.$t(value)+"<br />";
                            }); 
                        }else{
                            text = self.$t(value.returnMsg);
                        }

                        self.$swal.fire({
                            type: 'error',
                            html: text,
                            onClose: () => {
                                self.$bvModal.hide('getEditAttributeBadge');
                                self.getAttributeBadge();
                            }
                        });
                    }
                });
            }
        },deleteAttributeBadge(){
            if(this.permissionList.includes(this.permission.attribute_delete)){
                this.$swal.fire({
                    text: this.$t('msg.confirm_delete'),
                    type: 'info',
                    showCancelButton: true,
                    confirmButtonText: this.$t('button.confirm'),
                    cancelButtonText: this.$t('button.cancel'),
                }).then((result)=>{
                    if(result.value){
                        var self = this;
                        self.preloader(true);
                        var formData = new FormData();
                        formData.append(this.csrfNameKey, this.csrfName); 
                        formData.append(this.csrfValueKey, this.csrfValue); 
                        formData.append('id', this.ajaxAttributeRow); 
                        var result = badgeAttributeDelete(formData);		
                        result.then(function(value){
                            self.preloader(false);
                            if(value.valid){
                                self.$swal.fire({
                                    type: 'success',
                                    text: self.$t(value.returnMsg),
                                    onClose: () => {
                                        self.getAttributeBadge();
                                    }
                                });
                            }else{
                                self.preloader(false);
                                var text = "";
                                if(Array.isArray(value.returnMsg)){
                                    value.returnMsg.forEach(function (value) {
                                        text += self.$t(value)+"<br />";
                                    }); 
                                }else{
                                    text = self.$t(value.returnMsg);
                                }

                                self.$swal.fire({
                                    type: 'error',
                                    html: text,
                                    onClose: () => {
                                        self.getAttributeBadge();
                                    }
                                });
                            }
                        });
                    }
                });
            }
        },paginationAttributeSizeChange(limit){
            var self = this;
            var result = badgeAttributeLimit(this.ajaxRow,limit);
            this.preloader(true);
            result.then(function(value){
                self.preloader(false);
                if(value.valid){
                    self.ajaxLoad = true;
                    self.pageAttributeLimit = limit;
                    self.ajaxAttributeTable = value.data.datatable.data;
                    self.ajaxAttributeList = value.data.attribute_list;
                    self.ajaxAttributeBadge = value.data.badge.code;
                    self.ajaxAttributeTool = value.data.datatable;
                    self.csrfName = value.data.csrf_list.csrf_name;
                    self.csrfValue = value.data.csrf_list.csrf_value;
                    self.csrfNameKey = value.data.csrf_list.csrf_name_key;
                    self.csrfValueKey = value.data.csrf_list.csrf_value_key;
                }
            });
        },paginationAttributeCurrentChange(current){
            var self = this;
            var result = badgeAttributePagination(this.ajaxRow,current,this.pageAttributeLimit);
            this.preloader(true);
            result.then(function(value){
                self.preloader(false);
                if(value.valid){
                    self.ajaxLoad = true;
                    self.ajaxAttributeTable = value.data.datatable.data;
                    self.ajaxAttributeList = value.data.attribute_list;
                    self.ajaxAttributeBadge = value.data.badge.code;
                    self.ajaxAttributeTool = value.data.datatable;
                    self.csrfName = value.data.csrf_list.csrf_name;
                    self.csrfValue = value.data.csrf_list.csrf_value;
                    self.csrfNameKey = value.data.csrf_list.csrf_name_key;
                    self.csrfValueKey = value.data.csrf_list.csrf_value_key;
                }
            });
        }
    },created(){
        this.preloader(false);
        this.initialize();
    }
}
</script>
